module.exports = __webpack_public_path__ + "img/product_xd_1.72b6cc29.jpg";